import type { SiteType } from '@/app/types';

export const getQ4ModelVersionTitle = (site: SiteType): string =>
  site === 'china' ? 'Vidu Q4 预览版' : 'Vidu Q4 Preview';
